import React from 'react';
import { FaToolbox } from 'react-icons/fa';

export default function Footer({ copyright, contactEmail }: { copyright: string; contactEmail: string }) {
  return (
    <footer id="site-footer" className="ek-footer" data-testid="site-footer">
      <div className="ek-footer-inner">
        <div className="ek-footer-brand">
          <picture>
            <source srcSet="/assets/brand/ekuba-logo-sm.webp" type="image/webp" />
            <img className="ek-footer-logo" src="/assets/brand/ekuba-logo-sm.png" alt="The Ekuba Project" width={420} height={209} loading="lazy" draggable={false} data-testid="footer-logo-image" />
          </picture>
          <p className="ek-footer-tag">Music Has No Borders.</p>
        </div>

        <a
          href="https://210codelabs.com"
          target="_blank"
          rel="noopener noreferrer"
          className="ek-footer-partner"
          aria-label="Built by 210 Codelabs"
          title="Built by 210 Codelabs"
          data-testid="footer-partner-link"
        >
          <span className="ek-footer-partner-tag">Built by</span>
          <img
            src="/assets/brand/partners/210codelabs.png"
            srcSet="/assets/brand/partners/210codelabs-600.png 600w, /assets/brand/partners/210codelabs.png 1554w"
            sizes="(max-width: 640px) 160px, 220px"
            alt="210 Codelabs"
            width={1554}
            height={527}
            loading="lazy"
            draggable={false}
            className="ek-footer-partner-logo"
            data-testid="footer-partner-logo"
          />
        </a>

        <p className="ek-footer-copy" data-testid="footer-copyright">
          {contactEmail ? (
            <a href={`mailto:${contactEmail}`} className="ek-footer-mail" data-testid="footer-contact-email">
              {contactEmail}
            </a>
          ) : null}
          <a href="/press" className="ek-footer-press" data-testid="footer-press-link">
            Press Kit
          </a>
          <a href="/legal/privacy" className="ek-footer-legal" data-testid="footer-privacy-link">
            Privacy
          </a>
          <a href="/legal/terms" className="ek-footer-legal" data-testid="footer-terms-link">
            Terms
          </a>
          <a href="/admin" className="ek-footer-admin" aria-label="Admin panel" title="Admin panel" data-testid="footer-admin-link">
            {FaToolbox({ size: 10, 'aria-hidden': true })}
          </a>
          {copyright}
        </p>
      </div>
      <div className="ek-footer-base" aria-hidden="true" />
    </footer>
  );
}
